<template>
	<div v-loading.fullscreen.lock="loading" class="policyDe">
		<div class="policyDeCon">
			<div class="left">
				<div class="head">
					<div v-if="detail.company" class="name">
						{{detail.company.company_name}}
					</div>
					<div class="time">
						<!-- 1小时前发布 -->
						{{detail.issuance_date}}发布
					</div>
					<div class="pageView">
						{{detail.view_count}}次浏览
					</div>
				</div>
				<div class="center">
					<div class="name">
						{{detail.title}}
					</div>
					<div class="time">
						申报时间：{{detail.application_start_date}}-{{detail.application_end_date}}
					</div>
				</div>
				<div class="bottom">
					<el-image :src="detail.cover_image" fit="cover" class="img"></el-image>
					<div class="descbox" v-if="detail.description">
						<div class="title">政策简介：</div>
						<div class="desc">{{detail.description}}</div>
					</div>
					<div class="descbox" v-if="detail.description">
						<div class="title">政策正文：</div>
						<div style="white-space: pre-line;font-size: 16px;">
							{{detail.text_content}}
						</div>
					</div>
					
				</div>
			</div>
			<div class="right">
				<downCode></downCode>
				<div class="signUp" v-loading="singLoading">
					<div class="num">
						{{detail.registered_count}}人 <span>已报</span>
					</div>
					<div class="restrict">
						{{detail.application_limit?detail.application_limit:'不限'}}名额
					</div>
					<el-button type="primary" class="button" :disabled="is_apply==1" @click="SignUp()">{{is_apply?'已报名':'申请报名'}}</el-button>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import downCode from '@/components/downCode.vue'
	export default {
		name:'policyDe',
		components: {
			downCode
		},
		data() {
			return {
				id:'',
				detail:'',
				loading:false,
				is_apply:0,
				singLoading:false,
			}
		},
		created() {
			this.id=this.$route.query.id
			this.getDetail()
		},
		methods: {
			getDetail(){
				this.loading = true
				this.$axios.get('/api/client/Policy/getPolicysDetails',{params:{id:this.id}}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.detail=res.data
						this.is_apply = res.is_apply;
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			},
			SignUp(){
				if(this.is_apply) return;
				this.singLoading = true
				let data={
					policy_id:this.id
				}
				this.$axios.post('/api/client/ES/policysApplication', data).then(res => {
					this.singLoading = false
					if (res.code == 200) {
						this.is_apply = 1
						this.detail.registered_count++
						this.$eltips(res.msg)
					} else {
						this.$eltips(res.msg,'error')
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.policyDe{
		position: relative;
		padding: 38px 0;
		display: flex;
		justify-content: center;
		
		.policyDeCon{
			display: flex;
			margin: 0 auto;
			width: 1200px;
			position: relative;
			z-index: 2;
			.left{
				flex: 1;
				background-color: #FFF;
				border-radius: 16px;
				padding: 25px 38px 33px;
				margin-right: 16px;
				.head{
					display: flex;
					align-items: center;
					color: #151515;
					font-size: 16px;
					margin-bottom: 18px;
					.name{
						padding-right: 14px;
						border-right: 1px solid #B8B8B8;
						margin-right: 14px;
					}
					.pageView{
						flex: 1;
						text-align: right;
						margin-left: 20px;
					}
				}
				.center{
					color: #151515;
					margin-bottom: 18px;
					.name{
						font-size: 26px;
						margin-bottom: 18px;
						font-weight: bold;
					}
					.time{
						font-size: 16px;
					}
				}
				.bottom{
					color: #151515;
					font-size: 20px;
					text-align: justify;
					.img{
						margin-bottom: 18px;
						max-width: 80%;
						height: auto;
						display: block;
						margin: 0 auto;
					}
					
					.descbox{
						margin-top: 18px;
						text-align: justify;
						.title{
							font-size: 16px;
							font-weight: bold;
							margin-bottom: 12px;
						}
						.desc{
							font-size: 14px;
							background: #F5F5F5;
							padding: 14px;
							border-radius: 14px;
							white-space: pre-line; 
						}
					}
				}
			}
		
		    .right{
				.signUp{
					margin-top: 16px;
					color: #51A190;
					padding: 28px 28px 16px;
					width: 229px;
					box-sizing: border-box;
					background-color: #FFF;
					border-radius: 16px;
					.num{
						font-size: 22px;
						margin-bottom: 6px;
						span{
							font-size: 13px;
						}
					}
					.restrict{
						font-size: 13px;
						margin-bottom: 23px;
						color: #151515;
					}
					.button{
						width: 176px;
						height: 45px;
						border-radius: 8px;
						font-size: 16px;
					}
				}
			}
		}
	}
</style>